export default "__VITE_ASSET__13e1cd98__"